import { NavData } from "../NavData";
import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import Collapse from "../../pageComponents/Collapse/Collapse";

function Navitems({ setShowCancelButton, showSidebar, show, setShow }) {
  const router = useLocation();
  const [ID, setID] = useState(0);
  const handleNavLinks = (val) => {
    if (val.subTitle) {
      setID((prevID) => (prevID === val.id ? null : val.id)); // Toggle the open state of the clicked subnav
      // document.body.style.overflow = "hidden";
    } else {
      setShow(false);
      setID((prevID) => (prevID === val.id ? val.id : null)); // Toggle the open state of the clicked subnav

      setShowCancelButton(false);

      // document.body.style.overflow = "auto";
    }
  };

  return (
    <div className={`${showSidebar ? "tablet:mt-1" : ""}`}>
      <div className="  ">
        {NavData?.map((val, i) => {
          return (
            <div className="relative" key={i}>
              <NavLink
                to={val.path}
                onClick={() => handleNavLinks(val)}
                className={` ${
                  router.pathname === val.path
                    ? "bg-secondMainColor/20 text-white border-l-2 border-secondMainColor"
                    : "hover:bg-sidebarHover text-slate-400 hover:text-slate-200 border-l-2 border-transparent"
                }
          ${val.subTitle?.map((vals) => vals.paths === router.pathname ? "!bg-secondMainColor/20 !text-white" : null)}
         tablet:mb-1 px-3 my-1 font-medium cursor-pointer rounded-r-lg capitalize
         flex mx-2 gap-3 relative items-center py-2.5 transition-all
          `}
              >
                <div> {val.icon}</div>
                <div className="flex justify-between w-full">
                  <div
                    className={`${showSidebar ? "block tablet:hidden" : ""}`}
                  >
                    {val.title}
                  </div>
                  {ID === val.id ? (
                    <div
                      className={`${
                        showSidebar ? "hidden" : "block"
                      } text-2xl px-8`}
                    >
                      {val.icon1}
                    </div>
                  ) : (
                    <div
                      className={` ${
                        showSidebar ? "hidden" : "block"
                      } text-2xl px-8`}
                    >
                      {val.icon2}
                    </div>
                  )}
                </div>
              </NavLink>

              <Collapse
                showSidebar={showSidebar}
                setShowCancelButton={setShowCancelButton}
                isOpen={val.id === ID}
                title={val.title}
                setShow={setShow}
              >
                {val.subTitle?.map((sub, index) => {
                  return (
                    <NavLink
                      to={sub.paths}
                      key={index}
                      onClick={() => setID("")}
                    >
                      <div
                        className={` ${
                          router.pathname === sub.paths
                            ? "bg-secondMainColor/20 text-white font-medium"
                            : "hover:bg-sidebarHover text-slate-400 hover:text-slate-200"
                        }
             w-[95%] capitalize mx-auto px-4 h-fit tablet:my-1 my-1 font-medium text-sm
               cursor-pointer rounded-lg flex items-center gap-2 py-2.5 transition-all
                 `}
                      >
                        <div
                          className={` ${showSidebar ? "w-fit mx-auto" : ""}`}
                        >
                          {" "}
                          {sub.icon}
                        </div>
                        <div
                          className={` ${
                            showSidebar ? "hidden" : show ? "block" : "block"
                          } `}
                        >
                          {sub.sub_title}
                        </div>
                      </div>
                    </NavLink>
                  );
                })}
              </Collapse>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Navitems;
